var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRaListLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_9673",
    "data-name": "Group 9673",
    transform: "translate(-20 -351)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2999",
    "data-name": "Rectangle 2999",
    width: 24,
    height: 24,
    transform: "translate(20 351)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_9674",
    "data-name": "Group 9674",
    transform: "translate(-18.199 242.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "project_13863184",
    transform: "translate(40.369 109)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9672",
    "data-name": "Group 9672",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2551",
    "data-name": "Path 2551",
    d: "M11,2.556V8.121a.547.547,0,0,0,.556.556h5.565a.547.547,0,0,0,.556-.556V2.556A.547.547,0,0,0,17.121,2H11.556A.547.547,0,0,0,11,2.556Zm1.113.556h4.452V7.565H12.113Z",
    transform: "translate(-11 -2)",
    fill: "#2b7a78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2552",
    "data-name": "Path 2552",
    d: "M17.677,46.556A.547.547,0,0,0,17.121,46H11.556a.547.547,0,0,0-.556.556v5.565a.547.547,0,0,0,.556.556h5.565a.547.547,0,0,0,.556-.556Zm-1.113,5.008H12.113V47.113h4.452Z",
    transform: "translate(-11 -37.839)",
    fill: "#2b7a78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2553",
    "data-name": "Path 2553",
    d: "M17.121,90H11.556a.547.547,0,0,0-.556.556v5.565a.547.547,0,0,0,.556.556h5.565a.547.547,0,0,0,.556-.556V90.556A.547.547,0,0,0,17.121,90Zm-.556,5.565H12.113V91.113h4.452Z",
    transform: "translate(-11 -73.677)",
    fill: "#2b7a78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2554",
    "data-name": "Path 2554",
    d: "M64.906,26.29a2.406,2.406,0,0,0,2.411-2.411V11.266a2.406,2.406,0,0,0-2.411-2.411H57.895l.909-.909a.551.551,0,1,0-.779-.779L56.17,9.022a.574.574,0,0,0-.13.612.666.666,0,0,0,.13.185l1.855,1.855a.538.538,0,0,0,.779,0,.538.538,0,0,0,0-.779l-.909-.927h7.011a1.29,1.29,0,0,1,1.3,1.3V23.879a1.29,1.29,0,0,1-1.3,1.3H60.084a.556.556,0,1,0,0,1.113Z",
    transform: "translate(-47.656 -6.073)",
    fill: "#2b7a78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2555",
    "data-name": "Path 2555",
    d: "M55.556,106.113H56.3a.556.556,0,1,0,0-1.113h-.742a.556.556,0,1,0,0,1.113Z",
    transform: "translate(-46.839 -85.895)",
    fill: "#fff"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRaListLogo);
export default __webpack_public_path__ + "static/media/ra-list-logo.be970e19a3ba1b67f226ee93b74dcab7.svg";
export { ForwardRef as ReactComponent };